<div class="col-lg">
  <div class="media-container">
    <app-playlist [data]="media" #playlist (autoplay)="handleAutoplay($event)"></app-playlist>
    <div class="autoplay-blocker" *ngIf="screen"></div>
    <app-interactive [data]="media" (load)="handleLoad($event)"></app-interactive>
  </div>
</div>